import { Box, Button } from '@amzn/ring-ui-react-components';
import { useTranslation } from 'react-i18next';
import { Icon } from 'src/shared/components/Icon';

function getCountDescription(count: number) {
  return count;
}

export type ShareButtonProps = {
  count?: number;
  onClick?: () => void;
};

export const ShareButton = ({ count, onClick, ...props }: ShareButtonProps) => {
  const { t } = useTranslation('common');

  return (
    <Button size="xs" variant="ghost" onClick={onClick}>
      <Box
        {...props}
        cursor="pointer"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Icon name="share" color="white" size={24} />
        <Box color="white" textAlign="center" textStyle="body-normal-medium">
          {count && count > 0 ? getCountDescription(count) : t('share')}
        </Box>
      </Box>
    </Button>
  );
};
